import find from 'lodash/find';
import filter from 'lodash/filter';

export const SHORT_HAUL = 'short_haul';
const SHORT_HAUL_100_EXCEPTION = $localize`100 Air-Mile Exception`;
const SHORT_HAUL_150_EXCEPTION = $localize`150 Air-Mile Exception`;
const SHORT_HAUL_CDL_EXCEPTION = $localize`CDL Required Driver`;
const SHORT_HAUL_NON_CDL_EXCEPTION = $localize`Non-CDL Driver`;

export const ALBERTA_HOS_CYCLE = 'alberta';
export const CANADA_SOUTH_OIL_GAS = 'canada_oil';
export const FLORIDA_70_7_CYCLE = 'fl_70_7';
export const FLORIDA_70_7_P_CYCLE = 'fl_70_7_p';
export const FLORIDA_80_8_CYCLE = 'fl_80_8';
export const FLORIDA_80_8_P_CYCLE = 'fl_80_8_p';
export const TEXAS_70_7_CYCLE = 'tx_70_7';
export const OTHER_CYCLE = 'Other';
export const APP_VERSION_FOR_NEW_HOS_RULES = 32;
export const ADVERSE_DRIVING_EXCEPTION = 'adverseDriving';

export const CYCLE_MIN_APP_VERSION_MAPPING = {
  [ALBERTA_HOS_CYCLE]: 37,
  [FLORIDA_70_7_CYCLE]: 45,
  [FLORIDA_70_7_P_CYCLE]: 45,
  [FLORIDA_80_8_CYCLE]: 45,
  [FLORIDA_80_8_P_CYCLE]: 45,
};

const NEW_TO_OLD_RULES_MAPPING = {
  'us_short_haul_cdl': 'us_short_haul_100',
  'us_short_haul_cdl_60_7': 'us_short_haul_100',
  'us_short_haul_cdl_70_8': 'us_short_haul_100',

  'us_short_haul_cdl_p': 'us_short_haul_100_p',
  'us_short_haul_cdl_p_60_7': 'us_short_haul_100_p',
  'us_short_haul_cdl_p_70_8': 'us_short_haul_100_p',

  'us_short_haul_non_cdl': 'us_short_haul_150',
  'us_short_haul_non_cdl_60_7': 'us_short_haul_150',
  'us_short_haul_non_cdl_70_8': 'us_short_haul_150',

  'us_short_haul_non_cdl_p': 'us_short_haul_150_p',
  'us_short_haul_non_cdl_60_7_p': 'us_short_haul_150_p',
  'us_short_haul_non_cdl_70_8_p': 'us_short_haul_150_p',

  '70_8_2020': '70_8',
  '70_8_o_2020': '70_8_o',
  '60_7_2020': '60_7',
  '60_7_o_2020': '60_7_o',
};

const DEFINITIONS = [
  {
    name: $localize`USA Property 70 hour / 8 day`,
    shortName: $localize`USA 70 hour / 8 day`,
    abbreviation: $localize`USA PROPERTY 70/8`,
    value: '70_8',
    type: 'property',
    group: '70_8',
    exceptions: ['restart', 'restBreak', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`USA Property 70 hour / 8 day`,
    shortName: $localize`USA 70 hour / 8 day`,
    abbreviation: $localize`USA PROPERTY 70/8`,
    value: '70_8_2020',
    type: 'property',
    group: '70_8',
    exceptions: ['restart', 'restBreak', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    days: 8,
    isNew: true, // isNew indicates these rules are among New HOS Rules
  }, {
    name: $localize`USA Passenger 70 hour / 8 day`,
    shortName: $localize`USA 70 hour / 8 day`,
    abbreviation: $localize`USA PASSENGER 70/8`,
    value: '70_8_p',
    type: 'passenger',
    group: '70_8',
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`USA Oil and Gas 70 hour / 8 day`,
    shortName: $localize`USA 70 hour / 8 day`,
    abbreviation: $localize`USA OIL & GAS 70/8`,
    value: '70_8_o',
    type: 'oil_and_gas',
    group: '70_8',
    exceptions: ['restart', 'restBreak', 'waitTime', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 8,
  }, {
    name: $localize`USA Oil and Gas 70 hour / 8 day`,
    shortName: $localize`USA 70 hour / 8 day`,
    abbreviation: $localize`USA OIL & GAS 70/8`,
    value: '70_8_o_2020',
    type: 'oil_and_gas',
    group: '70_8',
    exceptions: ['restart', 'restBreak', 'waitTime', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 8,
    isNew: true,
  }, {
    name: $localize`USA Property 60 hour / 7 day`,
    shortName: $localize`USA 60 hour / 7 day`,
    abbreviation: 'USA PROPERTY 60/7',
    value: '60_7',
    type: 'property',
    group: '60_7',
    exceptions: ['restart', 'restBreak', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`USA Property 60 hour / 7 day`,
    shortName: $localize`USA 60 hour / 7 day`,
    abbreviation: 'USA PROPERTY 60/7',
    value: '60_7_2020',
    type: 'property',
    group: '60_7',
    exceptions: ['restart', 'restBreak', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    days: 7,
    isNew: true,
  }, {
    name: $localize`USA Passenger 60 hour / 7 day`,
    shortName: $localize`USA 60 hour / 7 day`,
    abbreviation: 'USA PASSENGER 60/7',
    value: '60_7_p',
    type: 'passenger',
    group: '60_7',
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`USA Oil and Gas 60 hour / 7 day`,
    shortName: $localize`USA 60 hour / 7 day`,
    abbreviation: 'USA OIL & GAS 60/7',
    value: '60_7_o',
    type: 'oil_and_gas',
    group: '60_7',
    exceptions: ['restart', 'restBreak', 'waitTime', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 7,
  }, {
    name: $localize`USA Oil and Gas 60 hour / 7 day`,
    shortName: $localize`USA 60 hour / 7 day`,
    abbreviation: 'USA OIL & GAS 60/7',
    value: '60_7_o_2020',
    type: 'oil_and_gas',
    group: '60_7',
    exceptions: ['restart', 'restBreak', 'waitTime', 'shortHaul', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 7,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_100',
    type: 'property',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_100_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_100_EXCEPTION,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_cdl',
    type: 'property',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_cdl_60_7',
    type: 'property',
    shortHaulWeek: '60_7',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_cdl_70_8',
    type: 'property',
    shortHaulWeek: '70_8',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_100_p',
    type: 'passenger',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_100_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_100_EXCEPTION,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_cdl_p',
    type: 'passenger',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_cdl_60_7_p',
    type: 'passenger',
    shortHaulWeek: '60_7',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_cdl_70_8_p',
    type: 'passenger',
    shortHaulWeek: '70_8',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_150',
    type: 'property',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_150_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_150_EXCEPTION,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_non_cdl',
    type: 'property',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_NON_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_NON_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_non_cdl_60_7',
    type: 'property',
    shortHaulWeek: '60_7',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_NON_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_NON_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_non_cdl_70_8',
    type: 'property',
    shortHaulWeek: '70_8',
    group: SHORT_HAUL,
    exceptions: ['restBreak', 'shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_NON_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_NON_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_150_p',
    type: 'passenger',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_150_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_150_EXCEPTION,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_non_cdl_p',
    type: 'passenger',
    shortHaulWeek: 'none',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_NON_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_NON_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_non_cdl_60_7_p',
    type: 'passenger',
    shortHaulWeek: '60_7',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_NON_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_NON_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`USA Short Haul`,
    shortName: $localize`USA Short Haul`,
    abbreviation: $localize`USA SHORT HAUL`,
    value: 'us_short_haul_non_cdl_70_8_p',
    type: 'passenger',
    shortHaulWeek: '70_8',
    group: SHORT_HAUL,
    exceptions: ['shortHaulDistance', 'shortHaul', 'restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restBreak: true,
      shortHaulDistance: SHORT_HAUL_NON_CDL_EXCEPTION,
    },
    days: 8,
    shortHaulDistanceException: SHORT_HAUL_NON_CDL_EXCEPTION,
    isNew: true,
  }, {
    name: $localize`California Property 80 hour / 8 day`,
    shortName: $localize`California 80 hour / 8 day`,
    abbreviation: $localize`CALIFORNIA PROPERTY 80/8`,
    value: '80_8',
    type: 'property',
    group: '80_8',
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`California Passenger 80 hour / 8 day`,
    shortName: $localize`California 80 hour / 8 day`,
    abbreviation: $localize`CALIFORNIA PASSENGER 80/8`,
    value: '80_8_p',
    type: 'passenger',
    group: '80_8',
    exceptions: ['farmSchoolBus', ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`California Oil and Gas 80 hour / 8 day`,
    shortName: $localize`California 80 hour / 8 day`,
    abbreviation: $localize`CALIFORNIA OIL & GAS 80/8`,
    value: '80_8_o',
    type: 'oil_and_gas',
    group: '80_8',
    exceptions: ['restart', 'waitTime', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 8,
  }, {
    name: $localize`Florida Property 70 hour / 7 day`,
    shortName: $localize`Florida 70 hour / 7 day`,
    abbreviation: $localize`FLORIDA PROPERTY 70/7`,
    value: FLORIDA_70_7_CYCLE,
    type: 'property',
    group: 'fl_70_7',
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`Florida Property 80 hour / 8 day`,
    shortName: $localize`Florida 80 hour / 8 day`,
    abbreviation: $localize`FLORIDA PROPERTY 80/8`,
    value: FLORIDA_80_8_CYCLE,
    type: 'property',
    group: 'fl_80_8',
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`Texas Property 70 hour / 7 day`,
    shortName: $localize`Texas 70 hour / 7 day`,
    abbreviation: $localize`TEXAS PROPERTY 70/7`,
    value: TEXAS_70_7_CYCLE,
    type: 'property',
    group: TEXAS_70_7_CYCLE,
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  },
  {
    name: $localize`Texas Passenger 70 hour / 7 day`,
    shortName: $localize`Texas 70 hour / 7 day`,
    abbreviation: $localize`TEXAS PASSENGER 70/7`,
    value: 'tx_70_7_p',
    type: 'passenger',
    group: TEXAS_70_7_CYCLE,
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
    },
    days: 7,
  },
  {
    name: $localize`Texas Oil and Gas 70 hour / 7 day`,
    shortName: $localize`Texas 70 hour / 7 day`,
    abbreviation: $localize`TEXAS OIL & GAS 70/7`,
    value: 'tx_70_7_o',
    type: 'oil_and_gas',
    group: TEXAS_70_7_CYCLE,
    exceptions: ['restart', 'waitTime', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 7,
  }, {
    name: $localize`Alaska Property 70 hour / 7 day`,
    shortName: $localize`Alaska 70 hour / 7 day`,
    abbreviation: $localize`ALASKA PROPERTY 70/7`,
    value: 'ak_70_7',
    type: 'property',
    group: 'ak_70_7',
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`Alaska Passenger 70 hour / 7 day`,
    shortName: $localize`Alaska 70 hour / 7 day`,
    abbreviation: $localize`ALASKA PASSENGER 70/7`,
    value: 'ak_70_7_p',
    type: 'passenger',
    group: 'ak_70_7',
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`Alaska Oil and Gas 70 hour / 7 day`,
    shortName: $localize`Alaska 70 hour / 7 day`,
    abbreviation: $localize`ALASKA OIL & GAS 70/7`,
    value: 'ak_70_7_o',
    type: 'oil_and_gas',
    group: 'ak_70_7',
    exceptions: ['restart', 'waitTime', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 7,
  }, {
    name: $localize`Alaska Property 80 hour / 8 day`,
    shortName: $localize`Alaska 80 hour / 8 day`,
    abbreviation: $localize`ALASKA PROPERTY 80/8`,
    value: 'ak_80_8',
    type: 'property',
    group: 'ak_80_8',
    exceptions: ['restart', ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`Alaska Passenger 80 hour / 8 day`,
    shortName: $localize`Alaska 80 hour / 8 day`,
    abbreviation: $localize`ALASKA PASSENGER 80/8`,
    value: 'ak_80_8_p',
    type: 'passenger',
    group: 'ak_80_8',
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 8,
  }, {
    name: $localize`Alaska Oil and Gas 80 hour / 8 day`,
    shortName: $localize`Alaska 80 hour / 8 day`,
    abbreviation: $localize`ALASKA OIL & GAS 80/8`,
    value: 'ak_80_8_o',
    type: 'oil_and_gas',
    group: 'ak_80_8',
    exceptions: ['restart', 'waitTime', ADVERSE_DRIVING_EXCEPTION],
    defaultExceptionValues: {
      restart: true,
      waitTime: true,
    },
    days: 8,
  }, {
    name: $localize`Canada South 70 hour / 7 day`,
    shortName: $localize`Canada South 70 hour / 7 day`,
    abbreviation: $localize`CANADA SOUTH 70/7`,
    value: '70_7',
    type: null,
    group: null,
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`Canada South 120 hour / 14 day`,
    shortName: $localize`Canada South 120 hour / 14 day`,
    abbreviation: $localize`CANADA SOUTH 120/14`,
    value: '120_14',
    type: null,
    group: null,
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 14,
  }, {
    name: $localize`Canada South Oil and Gas`,
    shortName: $localize`Canada South Oil and Gas`,
    abbreviation: $localize`CANADA SOUTH OIL & GAS`,
    value: CANADA_SOUTH_OIL_GAS,
    type: null,
    group: null,
    exceptions: ['waitTime', ADVERSE_DRIVING_EXCEPTION],
    days: 24,
  }, {
    name: $localize`Canada North 80 hour / 7 day (Cycle 1)`,
    shortName: $localize`Canada North 80 hour / 7 day`,
    abbreviation: $localize`CANADA NORTH 80/7`,
    value: '80_7',
    type: null,
    group: null,
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`Canada North 120 hour / 14 day (Cycle 2)`,
    shortName: $localize`Canada North 120 hour / 14 day`,
    abbreviation: $localize`CANADA NORTH 120/14`,
    value: '120_14_north',
    type: null,
    group: null,
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 14,
  }, {
    name: $localize`Alberta Provincial`,
    shortName: $localize`Alberta Provincial`,
    abbreviation: $localize`ALBERTA PROVINCIAL`,
    value: ALBERTA_HOS_CYCLE,
    type: null,
    group: null,
    exceptions: [ADVERSE_DRIVING_EXCEPTION],
    days: 7,
  }, {
    name: $localize`Other`,
    shortName: $localize`Other`,
    abbreviation: $localize`OTHER`,
    value: 'Other',
    type: null,
    group: null,
    exceptions: [],
    days: 14,
  },
];

export const CANADA_SOUTH_CYCLES = ['70_7', '120_14'];
export const CANADA_CYCLES = CANADA_SOUTH_CYCLES.concat(['canada_oil', '80_7', '120_14_north', 'alberta']);
const DEFAULT_CYCLE_DAYS = 14;

const TYPES = {
  property: $localize`Property`,
  passenger: $localize`Passenger`,
  oil_and_gas: $localize`Oil and Gas`,
};

export const SHORT_HAUL_WEEK_NAMES = {
  'none': $localize`None`,
  '60_7': $localize`60 Hours / 7 Days`,
  '70_8': $localize`70 Hours / 8 Days`,
};

/**
 * Compact base-rule labels for space-constrained surfaces (e.g. the FleetView HOS card).
 * Follows the confirmed Design mapping (region abbreviation + hours/days) and additionally keeps
 * the cycle TYPE (Property / Passenger / Oil & Gas) that the Design table omits, so same-hours
 * cycles of different types stay distinguishable. Keyed by cycle `value`. Distinct from
 * `abbreviation` (unchanged, still used by other surfaces); read via the `cardAbbreviation` getter.
 */
export const CYCLE_CARD_ABBREVIATIONS: Record<string, string> = {
  '70_8': $localize`US Property 70/8`,
  '70_8_2020': $localize`US Property 70/8`,
  '70_8_p': $localize`US Passenger 70/8`,
  '70_8_o': $localize`US Oil & Gas 70/8`,
  '70_8_o_2020': $localize`US Oil & Gas 70/8`,
  '60_7': $localize`US Property 60/7`,
  '60_7_2020': $localize`US Property 60/7`,
  '60_7_p': $localize`US Passenger 60/7`,
  '60_7_o': $localize`US Oil & Gas 60/7`,
  '60_7_o_2020': $localize`US Oil & Gas 60/7`,
  'us_short_haul_100': $localize`US Short Haul`,
  'us_short_haul_cdl': $localize`US Short Haul`,
  'us_short_haul_cdl_60_7': $localize`US Short Haul`,
  'us_short_haul_cdl_70_8': $localize`US Short Haul`,
  'us_short_haul_100_p': $localize`US Short Haul`,
  'us_short_haul_cdl_p': $localize`US Short Haul`,
  'us_short_haul_cdl_60_7_p': $localize`US Short Haul`,
  'us_short_haul_cdl_70_8_p': $localize`US Short Haul`,
  'us_short_haul_150': $localize`US Short Haul`,
  'us_short_haul_non_cdl': $localize`US Short Haul`,
  'us_short_haul_non_cdl_60_7': $localize`US Short Haul`,
  'us_short_haul_non_cdl_70_8': $localize`US Short Haul`,
  'us_short_haul_150_p': $localize`US Short Haul`,
  'us_short_haul_non_cdl_p': $localize`US Short Haul`,
  'us_short_haul_non_cdl_60_7_p': $localize`US Short Haul`,
  'us_short_haul_non_cdl_70_8_p': $localize`US Short Haul`,
  '80_8': $localize`CA Property 80/8`,
  '80_8_p': $localize`CA Passenger 80/8`,
  '80_8_o': $localize`CA Oil & Gas 80/8`,
  'fl_70_7': $localize`FL Property 70/7`,
  'fl_80_8': $localize`FL Property 80/8`,
  'tx_70_7': $localize`TX Property 70/7`,
  'tx_70_7_p': $localize`TX Passenger 70/7`,
  'tx_70_7_o': $localize`TX Oil & Gas 70/7`,
  'ak_70_7': $localize`AK Property 70/7`,
  'ak_70_7_p': $localize`AK Passenger 70/7`,
  'ak_70_7_o': $localize`AK Oil & Gas 70/7`,
  'ak_80_8': $localize`AK Property 80/8`,
  'ak_80_8_p': $localize`AK Passenger 80/8`,
  'ak_80_8_o': $localize`AK Oil & Gas 80/8`,
  '70_7': $localize`CAN S 70/7 (Cycle 1)`,
  '120_14': $localize`CAN S 120/14 (Cycle 2)`,
  'canada_oil': $localize`CAN S Oil & Gas`,
  '80_7': $localize`CAN N 80/7 (Cycle 1)`,
  '120_14_north': $localize`CAN N 120/14 (Cycle 2)`,
  'alberta': $localize`AB Provincial`,
  'Other': $localize`Other`,
};

export class Cycle {
  public type;
  public shortHaulWeek: string;
  public exceptions;
  public value;
  public abbreviation;

  constructor(def) {
    Object.keys(def).forEach(key => {
      this[key] = def[key];
    });
  }

  get typeName() { return this.type && TYPES[this.type]; }

  get shortHaulWeekLabel() { return this.shortHaulWeek && SHORT_HAUL_WEEK_NAMES[this.shortHaulWeek]; }

  get cardAbbreviation() { return CYCLE_CARD_ABBREVIATIONS[this.value] || this.abbreviation; }

  get isCanadian() { return CANADA_CYCLES.indexOf(this.value) >= 0; }

  get hasRestart() { return this.hasException('restart'); }

  get hasRestBreak() { return this.hasException('restBreak'); }

  get hasWaitTime() { return this.hasException('waitTime'); }

  get hasShortHaul() { return this.hasException('shortHaul'); }

  get hasShortHaulDistance() { return this.hasException('shortHaulDistance'); }

  get hasFarmSchoolBus() { return this.hasException('farmSchoolBus'); }

  get hasAdverseDriving() { return this.hasException(ADVERSE_DRIVING_EXCEPTION); }

  public hasException(name) {
    return this.exceptions.indexOf(name) >= 0;
  }
}

export const CYCLES = DEFINITIONS.map(def => new Cycle(def));

export function getCycle(value) {
  return find(CYCLES, { value });
}

export function cycleDays(value) {
  const cycle = getCycle(value);
  return cycle ? cycle.days : DEFAULT_CYCLE_DAYS;
}

export function cycleGroupOrValue(value) {
  const cycle = getCycle(value);
  return cycle && (cycle.group || cycle.value);
}

export function cycleType(value) {
  const cycle = getCycle(value);
  return cycle && cycle.type;
}

export function getShortHaulWeek(value) {
  const cycle = getCycle(value);
  return (cycle && cycle.shortHaulWeek) || 'none';
}

export function isCycleShortHaul(value) {
  const cycle = getCycle(value);
  return cycle && (cycle.group == SHORT_HAUL);
}

export function isCycleAlberta(value: string): boolean {
  return value === ALBERTA_HOS_CYCLE;
}

export function cycleShortHaulDistanceException(value) {
  const cycle = getCycle(value);
  return cycle && cycle.shortHaulDistanceException;
}

export function cycleFromGroupType(group, type, shortHaulWeek, shortHaulDistanceException?, useNewRules: boolean = true) {
  if (!group && !type) return;
  const cyclesWithGroup = filter(CYCLES, cycle => cycle.group === group &&
    (useNewRules ? cycle.isNew || !Object.values(NEW_TO_OLD_RULES_MAPPING).includes(cycle.value) : !cycle.isNew),
  );
  if (group == SHORT_HAUL && shortHaulDistanceException) {
    return cyclesWithGroup.length > 0
 ? find(cyclesWithGroup, { type, shortHaulWeek, shortHaulDistanceException })
 : find(CYCLES, { value: group, shortHaulWeek, shortHaulDistanceException });
  } else {
    return cyclesWithGroup.length > 0
 ? find(cyclesWithGroup, { type })
 : find(CYCLES, { value: group });
  }
}

export function cycleValueFromGroupType(group, type, shortHaulWeek, shortHaulDistanceException?, useNewRules: boolean = true) {
  const cycle = cycleFromGroupType(group, type, shortHaulWeek, shortHaulDistanceException, useNewRules);
  return cycle && cycle.value;
}

export function hasCyclesWithGroup(group) {
  return group && filter(CYCLES, { group }).length > 0;
}

export function mapOldAndNewCycle(cycle: string, appVersion?: number): string {
  /**
   * IF App version is 32 or greater and cycle is old, map them to new cycle rules otherwise return original cycle.
   * IF App version is older than 32 and cycle is new, map them to the old ones otherwise return original cycle.
   */

  const newCycles: string[] = Object.keys(NEW_TO_OLD_RULES_MAPPING);
  const oldCycles: string[] = Object.values(NEW_TO_OLD_RULES_MAPPING);

  if (!appVersion || appVersion >= 32) {
    return oldCycles.includes(cycle) ? newCycles.find(key => NEW_TO_OLD_RULES_MAPPING[key] === cycle) : cycle;
  } else {
    return newCycles.includes(cycle) ? NEW_TO_OLD_RULES_MAPPING[cycle] : cycle;
  }
}
